/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, Card } from '@coursera/cds-core';
import { ArrowNextIcon } from '@coursera/cds-icons';

import type { CtaConfigType } from 'bundles/coursera-plus-landing-page/components/pricePresentation/CourseraPlusAnnualPricePresentationV2Container';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

const styles = {
  ctaContainer: (customStyles?: CtaConfigType['customStyles']) => css`
    height: 100%;
    min-width: 300px;
    max-width: 350px;

    .cds-Card-base {
      background-color: ${customStyles?.backgroundColor} !important;
      border: 1px solid ${customStyles?.borderColor ?? 'transparent'} !important;
      border-radius: 8px !important;
    }
  `,

  cardContent: css`
    padding: var(--cds-spacing-200) var(--cds-spacing-300);
  `,
};

type Props = {
  config?: CtaConfigType;
  onClick: (productItemId?: string) => void;
  disabled: boolean;
};

const PriceCTA = ({ config, onClick, disabled }: Props) => {
  const {
    title,
    subTitle,
    ctaLabel,
    customStyles,
    buttonType = 'ghost',
    productItemId,
    loading,
    trackingName,
  } = config ?? {};
  const handleClick = () => {
    if (productItemId) {
      onClick(productItemId);
    }
  };
  return (
    <TrackedDiv
      css={styles.ctaContainer(customStyles)}
      trackingName={trackingName as string}
      trackClicks={true}
      withVisibilityTracking={true}
    >
      <Card interactive role="button" tabIndex={0} onClick={handleClick}>
        <div css={styles.cardContent}>
          {title}
          {subTitle}
          <Button
            variant={buttonType ?? 'ghost'}
            icon={<ArrowNextIcon />}
            loading={loading}
            textAlign={buttonType === 'ghost' ? 'start' : undefined}
            disabled={disabled}
            fullWidth={buttonType === 'primary'}
            edgeAlign={buttonType === 'ghost' ? 'start' : undefined}
          >
            {ctaLabel}
          </Button>
        </div>
      </Card>
    </TrackedDiv>
  );
};

export default PriceCTA;
